import React, { useState, useEffect } from "react";
import { IoIosClose } from "react-icons/io";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useForm } from "react-hook-form";
import RequestService from "../../services/RequestService";
import SgsService from '../../services/SgsService';
import { FaRegTrashAlt } from "react-icons/fa";
import MinorRequestDetails from './../molecules/MinorRequestDetails';
import { parseISO, format } from "date-fns";
import StatusRequests from '../../enums/StatusRequests'
import { MdSend } from "react-icons/md";
import { FaStamp } from "react-icons/fa";
import { IoMdPrint } from "react-icons/io";
import { FaSpinner } from "react-icons/fa";

export default function DispatchModal({
  isModalOpen,
  setModalOpen,
  requestId,
  requestNro,
  // setTicketCb
}) {
  const {
    register,
    handleSubmit,
    reset,
    getValues,
    setValue,
    formState: { errors },
  } = useForm();

  const [requestObject, setRequestObject] = useState();
  const [ updated, setUpdated ] = useState()

  const [manualSGS, setManualSGS] = useState(false);

  const [atualizadoSGRS, setAtualizadoSGRS] = useState(false);

  const [directInstallStatus, setDirectInstallStatus] = useState(false);

  const [ isLoading, setIsLoading ] = useState(false);
  
    const handleAtualizadoSGRSChange = (event) => {
      setAtualizadoSGRS(event.target.checked);
    };

  useEffect(() => {
    async function fetchRequest() {
      const request = await RequestService.getRequestById(requestId);
      setRequestObject(request);

      console.log(request?.request.idRequest);
    }

    fetchRequest();
  }, [isModalOpen, requestId, updated]);

  const onSubmit = async (data) => {

    if(requestObject?.request?.codItemsAtendidos?.length !== requestObject?.request?.quantidadeAtender){
      toast.error("Quantidade de itens insuficiente");
      return;
    }

    data = { ...data, status: "REPASSE PARA ENTREGA" };

    const response = await RequestService.updateParcial(requestId, data);

    if (response) {
      toast.success("Despachado!");
    } else {
      toast.error("Ops! Algo deu errado");
    }

    setModalOpen(!isModalOpen);
    setAtualizadoSGRS(false);
    setDirectInstallStatus(false);
    reset();
  };

  const onClose = () => {
    setModalOpen(!isModalOpen);
    setAtualizadoSGRS(false);
    setDirectInstallStatus(false);
    reset();
  };

  const handleAddItem = async () => {
    const codEquipamentoValue = getValues("codEquipamento");

    try {
        await RequestService.addItemToRequest(requestId, codEquipamentoValue);
        toast.success("Item adicionado!");
        setUpdated(!updated);
        reset();
    } catch (error) {
        toast.error(error.message);
    }
};

  const handleRemoveItem = async (cod) => {
    const response = await RequestService.removeItemFromRequest(requestId, cod);
    if (response) {
        // Item removido com sucesso, faça o que for necessário
        toast.success("Item removido!");
        setUpdated(!updated)
    } else {
        // Trate o erro, se necessário
        toast.error("Ops! Algo deu errado");
    }
  }

  const handleManualSGS = (event) => {
    setManualSGS(event.target.checked);
  };

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.ctrlKey && event.key === 'p') {
        event.preventDefault(); // Evita que o comportamento padrão do browser ocorra
        handlePrint();
      }
    };

    window.addEventListener('keydown', handleKeyPress);

    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, []);

  const handlePrint = () => {
    window.print();
  };

  const handleDirectInstall = async (data) => {
    const userConfirmed = window.confirm("Você realmente deseja executar esta ação? Você não poderá remover os itens após a execução.");
    if (!userConfirmed) {
      return;
    }
    setIsLoading(true); // Modifica isLoading para true antes da execução
    try {

      const data = {
        codSGS: requestObject?.request?.drsAtender?.codSGS,
        reTecnico: requestObject?.request?.reTecnico,
        idRequest: requestObject?.request?.idRequest,
        site: requestObject?.request?.gmo.codSGS,
        codItemsAtendidos: requestObject?.request?.codItemsAtendidos,
      };

      const response = await SgsService.directInstall(data);
      if (response) {
        toast.success("Instalação Direta realizada com sucesso!");
        setUpdated(!updated);
        setDirectInstallStatus(true);
        reset();
      }
    } catch (error) {
      console.error('Error fetching search results:', error);
    } finally {
      setIsLoading(false); // Modifica isLoading para false após a execução
    }
  };

  if (isModalOpen) {
    return (
      <div
        className="flex flex-col relative z-10"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
      >
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto py-8"
          onClick={onClose}
        >
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <div className="flex flex-col w-fit max-w-[700px] h-fit pb-4 relative transform rounded-lg bg-white text-left shadow-xl transition-all" onClick={(e) => e.stopPropagation()}>
              { !directInstallStatus &&
                <button
                  onClick={onClose}
                  className="absolute -top-7 -right-7 rounded-full p-1"
                >
                  <div className="w-12 h-12 flex bg-gray-200 justify-center items-center rounded-full ms-6">
                    <div className="flex justify-center items-center">
                      <IoIosClose color={"black"} size={32} />
                    </div>
                  </div>
                </button>
              }
              <div className="flex flex-col px-4 pt-4 pb-3 text-left gap-2 bg-gray-800 text-white rounded-t-lg">

                <div className="flex justify-between gap-2">
                  <div className="flex gap-2 items-center text-white text-xl font-bold">
                    <MdSend />
                    DESPACHAR
                  </div>

                  {requestObject?.request?.isReplica &&
                    <div>
                      <p className="text-black font-bold rounded-lg px-1 bg-yellow-300">
                        RÉPLICA SGRS
                      </p>
                    </div>
                  }
                </div>

                <div className="ms-4 flex justify-between gap-4">
                  <div className="text-sm">
                    Solicitação nº: {requestObject?.request?.idRequest}
                  </div>
                  <div className="text-sm">
                    {/* Criado em: {requestObject?.request?.createdAt } */}
                    Criado em: {requestObject && format(parseISO(requestObject?.request?.createdAt), 'dd/MM/yy HH:mm')}
                  </div>
                  <div className="flex items-center gap-2">
                    Status:
                    <p  className="text-sm text-black rounded-lg px-2"
                        style={{ backgroundColor: StatusRequests[requestObject?.request?.status]?.cor }}>
                      {requestObject?.request?.status}
                    </p>
                  </div>
                </div>
              </div>

              <MinorRequestDetails request={requestObject?.request} localizacaoEquip={true} carimboDespacho={true} divContato={true}/>

              <div className="flex justify-end gap-2 h-5 text-[11px] px-4 mt-1">
                <button 
                  className="flex items-center gap-1 bg-gray-500 rounded-full px-2 text-white w-fit"
                  onClick={handlePrint}
                  >
                  Imprimir
                  <IoMdPrint />
                </button>
              </div>

              {/* MODAL FORM BEGIN */}

              <div className="flex flex-col mt-6 px-4 text-xs">
                <div className="w-full relative inline-block text-left">
                  <div className="w-full flex flex-col gap-2 px-4">

                    <div className="flex flex-col items-start gap-1 mb-4 w-full">
                      <label className="w-1/5 block text-gray-700 font-bold whitespace-nowrap">
                        Cód Equipamento:
                      </label>
                      <div className="w-full flex gap-2">
                        <input
                          type="text"
                          {...register("codEquipamento")}
                          className={`block w-full rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400
                              ${
                                errors?.codEquipamento?.type === "required"
                                  ? " border border-red-500 outline-none ring-0"
                                  : "border border-zinc-500 outline-none ring-0"
                              }
                              `}
                        />
                        <button 
                          onClick={()=>handleAddItem(requestId)}
                          className="bg-blue-500 text-white py-1 px-4 rounded-2xl hover:bg-blue-600"
                          >
                            Inserir
                        </button>
                      </div>
                      
                      {errors?.codEquipamento?.type === "required" && (
                        <p className="text-red-500 text-xs ms-2">
                          Campo obrigatório
                        </p>
                      )}

                      {/* DIV movimentações */}
                      { requestObject?.request?.codItemsAtendidos.length !== 0 &&
                      <div className="flex flex-col w-full max-h-60 overflow-y-auto border border-zinc-500 rounded-lg">
                        <table className="min-w-full bg-white text-xs">
                          <thead>
                            <tr className="bg-gray-200 text-black border-b">
                              <th className="px-6 py-1 rounded-tl-lg"><div className="flex items-center justify-center">#</div></th>
                              <th className="px-6 py-1"><div className="flex items-center justify-center">Código</div></th>
                              <th className="px-6 py-1 rounded-tr-lg"><div className="flex items-center justify-center">Ação</div></th>
                            </tr>
                          </thead>
                          <tbody>
                            {requestObject?.request?.codItemsAtendidos?.map((cod, index) => (
                              <tr key={index}>
                                {/* <td className="px-6 py-4 whitespace-nowrap border-b">{format(parseISO(movement.createdAt), 'dd/MM/yy HH:mm')}</td> */}
                                <td className="w-10 px-6 py-2 whitespace-nowrap border-b"><div className="flex items-center justify-center">{index + 1}</div></td>
                                <td className="px-6 py-2 whitespace-nowrap border-b"><div className="flex items-center justify-center">{cod}</div></td>
                                <td className="w-10 px-6 py-2 whitespace-nowrap border-b">
                                  <div className="flex items-center justify-center">
                                    { !directInstallStatus && !isLoading &&
                                      <button onClick={()=>{handleRemoveItem(cod)}}><FaRegTrashAlt color="red" size={14}/></button>
                                    }
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      }
                      <div>Quantidade lida: {requestObject?.request.codItemsAtendidos.length}</div>



                    </div>

                    {/* <div className="flex flex-col items-start gap-1 mb-4 w-full">
                      <label className="w-1/5 block text-gray-700 font-bold whitespace-nowrap">
                        Doc Relacionado Expedição:
                      </label>
                      <input
                        type="text"
                        {...register("docRelacionadoExpedicao", { required: true })}
                        className={`block w-full rounded-lg px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                            ${
                              errors?.docRelacionadoExpedicao?.type === "required"
                                ? " border border-red-500 outline-none ring-0"
                                : "border border-zinc-500 outline-none ring-0"
                            }
                            `}
                      />
                      {errors?.docRelacionadoExpedicao?.type === "required" && (
                        <p className="text-red-500 text-xs ms-2">
                          Campo obrigatório
                        </p>
                      )}
                    </div> */}<div className="flex flex-row gap-2 w-full">
                    
                    {/* <div className="flex flex-col items-start gap-1 mb-4 w-full">
                      <label className="w-1/5 block text-gray-700 font-bold whitespace-nowrap">Observação:</label>
                      <textarea
                        {...register("obsAtualizacao", { required: true })}
                        className={`
                              w-full h-[70px] p-4 bg-white rounded-2xl justify-start items-center inline-flex resize-none 
                              text-neutral-600 font-normal font-['Work Sans']
                              focus:border focus:border-zinc-800 focus:outline-none focus:ring-0
                              placeholder:text-neutral-400 placeholder:font-normal
                              ${
                                errors?.obsAtualizacao?.type === "required" ?
                                "border border-red-500 outline-none ring-0" : "border border-zinc-500 outline-none ring-0"
                          }
                          `}
                        placeholder={"Observação"}>
                      </textarea>
                      {errors?.obsAtualizacao?.type === "required" && (
                        <p className="text-red-500 text-xs whitespace-nowrap">
                          Campo obrigatório
                        </p>
                      )}
                    </div> */}
                    {/* <div className="flex flex-col items-start gap-1 mb-4 w-full">
                      <div className="flex gap-1 text-gray-700">
                        <FaStamp />
                        <label className="w-1/5 block text-gray-700 font-bold whitespace-nowrap">Carimbo:</label>
                      </div>
                        <textarea
                          disabled={true}
                          value={requestObject?.request?.ultimoCarimbo}
                          className={`
                                  w-full h-[60px] p-4 bg-white rounded-lg border border-zinc-300 justify-start items-center inline-flex resize-none 
                                  text-neutral-600 font-normal font-['Work Sans']
                                  focus:border focus:border-zinc-800 focus:outline-none focus:ring-0
                                  placeholder:text-neutral-400 placeholder:text-sm placeholder:font-normal placeholder:font-['Work Sans'] placeholder:leading-[14.34px]
                              `}
                        />
                      {errors?.carimbo?.type === "required" && (
                        <p className="text-red-500 text-xs whitespace-nowrap">
                          Campo obrigatório
                        </p>
                      )}
                    </div> */}

                  </div>

                    <div className="flex flex-col gap-2 text-xs">

                      <div className="flex gap-2">
                        <input
                          type="checkbox"
                          disabled={directInstallStatus ? true : false}
                          checked={manualSGS}
                          onChange={handleManualSGS}
                          className="form-checkbox h-4 w-4 text-blue-600"
                        />
                        <label className="text-gray-700 font-bold whitespace-nowrap">
                          Realizar Instalação Direta manualmente no SGS
                        </label>
                      </div>

                      {requestObject?.request?.isReplica &&
                        <div className="flex gap-2">
                          <input
                            type="checkbox"
                            checked={atualizadoSGRS}
                            onChange={handleAtualizadoSGRSChange}
                            className="form-checkbox h-4 w-4 text-blue-600"
                          />
                          <label className="text-gray-700 font-bold whitespace-nowrap">
                            Confirmo que já atualizei no SGRS
                          </label>
                        </div>
                      }

                      <div className="flex gap-1">
                        <label className="text-gray-700 font-bold whitespace-nowrap">
                          Status Instalação Direta:
                        </label>
                        {isLoading ? (
                          <FaSpinner className="animate-spin text-gray-500" />
                        ) : (
                          <span className={directInstallStatus ? " text-green-500" : " text-red-500"}>
                            {directInstallStatus ? "OK" : "Pendente"}
                          </span>
                        )}
                      </div>


                      {/* <button
                        disabled={(requestObject?.request?.codItemsAtendidos.length === requestObject?.request?.quantidadeAtender) && !manualSGS && !directInstallStatus ? false : true}
                        // disabled={true}
                        onClick={() => handleDirectInstall()}
                        className="w-full bg-yellow-500 text-white py-2 px-4 rounded-2xl hover:bg-yellow-600 disabled:bg-gray-300"
                        >
                        Instalação Direta (SGS)
                      </button> */}
                      {["bbn-alta", "bbn-media"].includes(requestObject?.request?.tipoAtendimento) ? (
                        <>
                          <button
                            disabled
                            className="w-full bg-yellow-500 text-white py-2 px-4 rounded-2xl disabled:bg-gray-300"
                          >
                            Instalação Direta (SGS)
                          </button>
                          <div className="text-red-500 text-xs font-bold mt-1">
                            Instalação Direta desabilitada para BBN. Realizar manualmente
                          </div>
                        </>
                      ) : (
                        <button
                          disabled={
                            (requestObject?.request?.codItemsAtendidos.length === requestObject?.request?.quantidadeAtender) &&
                              !manualSGS &&
                              !directInstallStatus
                              ? false
                              : true
                          }
                          onClick={() => handleDirectInstall()}
                          className="w-full bg-yellow-500 text-white py-2 px-4 rounded-2xl hover:bg-yellow-600 disabled:bg-gray-300"
                        >
                          Instalação Direta (SGS)
                        </button>
                      )}
                      <button
                        disabled={ !(manualSGS || directInstallStatus) || !(requestObject?.request?.codItemsAtendidos.length === requestObject?.request?.quantidadeAtender)}
                        onClick={() => handleSubmit(onSubmit)()}
                        className="w-full bg-blue-500 text-white py-2 px-4 rounded-2xl hover:bg-blue-600 disabled:bg-gray-300"
                        >
                        Enviar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
